var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgControllerReplay = function SvgControllerReplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.501,
    height: 15.5
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.752a.692.692 0 1 1 1.383 0 6.377 6.377 0 1 0 1.161-3.661h2.277a.692.692 0 0 1 0 1.384h-3.5a.693.693 0 0 1-.689-.693v-3.5a.692.692 0 1 1 1.383 0V2.55a7.744 7.744 0 1 1-2.012 5.2z",
    fill: "#fff"
  })));
};
export { SvgControllerReplay as ReactComponent };
export default "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"15.501\" height=\"15.5\"><path d=\"M0 7.752a.692.692 0 111.383 0 6.377 6.377 0 101.161-3.661h2.277a.692.692 0 010 1.384h-3.5a.693.693 0 01-.689-.693v-3.5a.692.692 0 111.383 0V2.55a7.744 7.744 0 11-2.012 5.2z\" fill=\"#fff\"/></svg>";